<template>
  <div class="main-content">
    <SectionTitle class="animate-target" v-animate-in icon="Q" :title="title"></SectionTitle>
    <QuestionBox :title="questionTitle" :desc="questionDesc" :items="questionItem" v-on:selected="selected" :index="questionAnswer" ></QuestionBox>
    <GoNext class="animate-target" v-animate-in href="/section1/1-2" :selected="selectedValue" required="true"></GoNext>
    <ContentNotice class="animate-target" v-animate-in :txt="noticeTxt" />
  </div>
</template>

<script>
import QuestionBox from "../../components/QuestionBox";
import SectionTitle from "../../components/SectionTitle";
import GoNext from "../../components/GoNext";
import ContentNotice from "../../components/ContentNotice";
export default {
  name: "s1-1",
  components: {SectionTitle, QuestionBox, GoNext, ContentNotice},
  data(){
    return {
      questionTitle: "Question 1",
      questionDesc: "Guidelines recommend assessment of kidney function in T2D using:",
      questionItem:[
          "Urinary albumin (UACR)",
          "Estimated glomerular filtration rate (eGFR)",
          "UACR and eGFR",
          "Blood pressure (BP)"
      ],
      selectedValue:'',
      questionAnswer:'2',
      title:'Pre-activity quiz',
      noticeTxt:"CKD, chronic kidney disease, T2D, type 2 diabetes.<br/><div class='brs'></div>Reference: <br/><div class='brs'></div>1. RACGP. Management of type 2 diabetes: A handbook for general practice. <a target='_blank' href='https://www.racgp.org.au/getattachment/7c05e922-ab1f-4301-aab7-f4f9b638cb66/Management-of-type-2-diabetes-A-handbook-for-general-practice.aspx' class='c-url'>https://www.racgp.org.au/getattachment/7c05e922-ab1f-4301-aab7-f4f9b638cb66/Management-of-type-2-diabetes-A-handbook-for-general-practice.aspx</a>",
    };
  },
  methods:{
    selected:function(value){
      this.selectedValue = value;
    }
  }
}
</script>

<style scoped>

</style>
